/* Product page + landing hero: gallery (swipe / zoom / variant image), variant picker, bundle tiers,
   engraving counter, quantity, sticky add to bag, recommendations, frequently bought together. */
(() => {
  'use strict';
  /* theme.js loads at the end of <body>, after this section's script: wait for its helpers */
  const boot = () => {
  const T = window.theme; if (!T || !T.$$ || boot.done) return; boot.done = true;
  const { $, $$ } = T;
  /* sale chip as a percent (theme.js T.priceHTML shows Save $X): Save 10% = round((compare - price) / compare), from 1% */
  if (!T.pctPrice) { T.pctPrice = true; T.priceHTML = (price, compare) => { const pct = compare && compare > price ? Math.round(((compare - price) * 100) / compare) : 0; return compare && compare > price ? `<span class="price"><span class="price__sale">${T.money(price)}</span><s>${T.money(compare)}</s>${pct >= 1 ? `<span class="save-chip">Save ${pct}%</span>` : ''}</span>` : `<span class="price"><span>${T.money(price)}</span></span>`; }; }

  /* quick view (assets/quick-view.js) runs the same product logic on a product section fetched into its modal */
  T.initProduct = init;
  $$('[data-product]').forEach((r) => { if (!r.closest('[data-qv]')) init(r); });

  function init(root) {
    const wrap = root.closest('.shopify-section') || document;
    let data; try { data = JSON.parse($('[data-product-json]', wrap).textContent); } catch (e) { return; }
    const form = $('[data-product-form]', root), idInput = form && $('[data-variant-input]', form);
    const addBtn = form && $('[data-add-button]', form), addLabel = form && $('[data-add-label]', form);
    const sticky = $('[data-sticky-atc]', wrap);
    const track = $('[data-track]', root);
    let current = data.variants.find((v) => String(v.id) === (idInput && idInput.value)) || data.variants[0];

    /* gallery */
    if (track) {
      const slides = $$('.gallery__slide', track), thumbs = $$('[data-thumb]', root), dots = $$('.gallery__dots span', root);
      const go = (i, smooth = true) => { const s = slides[i]; if (s) track.scrollTo({ left: s.offsetLeft, behavior: smooth ? 'smooth' : 'auto' }); };
      thumbs.forEach((t, i) => t.addEventListener('click', () => go(i)));
      let raf; track.addEventListener('scroll', () => {
        cancelAnimationFrame(raf); raf = requestAnimationFrame(() => {
          const i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
          thumbs.forEach((t, k) => t.setAttribute('aria-current', String(k === i)));
          dots.forEach((d, k) => d.classList.toggle('is-active', k === i));
          const gi = $('[data-gallery-index]', root); if (gi) gi.textContent = Math.min(i + 1, slides.length);
          slides.forEach((s, k) => { if (k !== i) s.classList.remove('is-zoomed'); });
        });
      }, { passive: true });
      track.addEventListener('keydown', (e) => {
        const i = Math.round(track.scrollLeft / track.clientWidth);
        if (e.key === 'ArrowRight') { e.preventDefault(); go(Math.min(slides.length - 1, i + 1)); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); go(Math.max(0, i - 1)); }
      });
      /* tap/click (or the zoom button) opens a clean full-screen viewer: native dialog gives Esc + focus return,
         swipe or arrow keys move between images, pinch-zoom works on phones */
      const zoomer = $('[data-zoomer]', wrap);
      if (zoomer && zoomer.showModal) {
        const zt = $('[data-zoomer-track]', zoomer), zi = $('[data-zoomer-index]', zoomer), zs = $$('[data-zoom-id]', zoomer);
        let opener = null;
        const open = (sl, from) => {
          opener = from; zoomer.showModal(); document.documentElement.style.overflow = 'hidden';
          const t = $(`[data-zoom-id="${sl.dataset.mediaId}"]`, zoomer), k = Math.max(0, zs.indexOf(t));
          zt.scrollTo({ left: t ? t.offsetLeft : 0, behavior: 'auto' }); zi.textContent = k + 1;
          $('[data-zoomer-close]', zoomer).focus();
        };
        slides.forEach((sl) => {
          const im = $('img', sl); if (!im) return; im.style.cursor = 'zoom-in';
          im.addEventListener('click', (e) => { e.stopImmediatePropagation(); open(sl, $('[data-zoom]', sl) || track); }, true);
          const zb = $('[data-zoom]', sl); zb && zb.addEventListener('click', () => open(sl, zb));
        });
        zt.addEventListener('scroll', () => { zi.textContent = Math.round(zt.scrollLeft / Math.max(1, zt.clientWidth)) + 1; }, { passive: true });
        zoomer.addEventListener('keydown', (e) => {
          if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
          e.preventDefault(); zt.scrollBy({ left: (e.key === 'ArrowRight' ? 1 : -1) * zt.clientWidth, behavior: 'auto' });
        });
        $('[data-zoomer-close]', zoomer).addEventListener('click', () => zoomer.close());
        zoomer.addEventListener('close', () => { document.documentElement.style.overflow = ''; opener && opener.focus && opener.focus({ preventScroll: true }); });
        zoomer.addEventListener('click', (e) => { if (e.target === zoomer || e.target.classList.contains('zoomer__slide')) zoomer.close(); });
      } else {
        /* no viewer (landing hero): click to zoom in place, following the cursor */
        const fine = matchMedia('(hover: hover) and (pointer: fine)').matches;
        slides.forEach((s) => {
          const img = $('img', s); if (!img) return;
          const toggle = () => s.classList.toggle('is-zoomed');
          if (fine) { img.style.cursor = 'zoom-in'; img.addEventListener('click', toggle); }
          const zb = $('[data-zoom]', s); zb && zb.addEventListener('click', toggle);
          s.addEventListener('mousemove', (e) => { if (!s.classList.contains('is-zoomed')) return; const r = s.getBoundingClientRect(); img.style.transformOrigin = `${((e.clientX - r.left) / r.width) * 100}% ${((e.clientY - r.top) / r.height) * 100}%`; });
          s.addEventListener('mouseleave', () => s.classList.remove('is-zoomed'));
        });
      }
      root._goToMedia = (mediaId) => { const i = slides.findIndex((s) => s.dataset.mediaId === String(mediaId)); if (i >= 0) go(i); };
    }

    /* variant picker */
    const picker = $('[data-variant-picker]', root);
    const selected = () => $$('fieldset', picker).map((fs) => { const c = $('input:checked', fs); return c ? c.value : null; });
    const tiers = $('[data-tiers]', root);
    const tierVariant = () => {
      if (!tiers) return null;
      const t = $('[data-tier]:checked', tiers); if (!t) return null;
      let tj; try { tj = JSON.parse($('[data-tier-json]', t.closest('.tier')).textContent); } catch (e) { return null; }
      const opts = picker ? selected() : [];
      return tj.variants.find((v) => v.available && opts.some((o) => v.options.includes(o))) || tj.variants.find((v) => v.available) || tj.variants[0];
    };
    /* rows marked data-need start unselected (letter, month, size): the button stays live and asks for the choice on tap */
    let incomplete = false;
    const update = (fromUser) => {
      if (picker) {
        const opts = selected();
        incomplete = opts.some((o) => o === null);
        current = incomplete ? null : data.variants.find((v) => v.options.every((o, i) => o === opts[i])) || null;
        opts.forEach((o, i) => { const l = $(`[data-option-label="${i}"]`, picker); if (l && o !== null) l.textContent = o; });
        /* mark values that can't be bought with the other current selections (unchosen rows match anything) */
        $$('fieldset', picker).forEach((fs, idx) => $$('input', fs).forEach((inp) => {
          const test = opts.slice(); test[idx] = inp.value;
          const ok = data.variants.some((x) => x.available && x.options.every((o, i) => test[i] === null || o === test[i]));
          inp.classList.toggle('is-unavailable', !ok);
        }));
      }
      const chosen = tierVariant() || current;
      const ok = incomplete || (chosen && chosen.available);
      if (idInput && chosen) idInput.value = chosen.id;
      if (addBtn) addBtn.disabled = !ok;
      if (addLabel) addLabel.textContent = incomplete || ok ? T.strings.addToBag : !chosen ? T.strings.unavailable : T.strings.soldOut;
      const pw = $('[data-price-wrap]', root); if (pw && chosen) pw.innerHTML = T.priceHTML(chosen.price, chosen.compare_at_price);
      $$('[data-paylater]', root).forEach((b) => { if (chosen) b.textContent = T.money(Math.round(chosen.price / 4)); });
      const av = $('[data-avail]', root);
      if (av && chosen) { av.classList.toggle('avail--out', !chosen.available); $('[data-avail-text]', av).textContent = chosen.available ? (T.strings.inStock || 'Available in stock') : (T.strings.soldOut || 'Out of stock'); }
      const sku = $('[data-sku]', root); if (sku && chosen) sku.textContent = chosen.sku || '—';
      const stock = $('[data-stock]', root);
      if (stock && current) {
        const low = current.inventory != null && current.inventory > 0 && current.inventory <= data.lowStock;
        stock.hidden = !low; if (low) stock.textContent = stock.textContent.replace(/\d+/, current.inventory);
      }
      if (sticky) {
        const sp = $('[data-sticky-price]', sticky); sp && chosen && (sp.innerHTML = T.priceHTML(chosen.price));
        const sv = $('[data-sticky-variant]', sticky); if (sv) sv.textContent = current && current.title !== 'Default Title' ? current.title : '';
        const sb = $('[data-sticky-button]', sticky); if (sb) { sb.disabled = !ok; const sl = $('.btn__label', sb); sl && addLabel && (sl.textContent = addLabel.textContent); }
      }
      if (fromUser && current && !tiers && !root.closest('[data-qv]')) {
        const url = new URL(location.href); url.searchParams.set('variant', current.id); history.replaceState(null, '', url);
        if (current.media_id && root._goToMedia) root._goToMedia(current.media_id);
      } else if (fromUser && current && current.media_id && root._goToMedia) root._goToMedia(current.media_id);
    };
    picker && picker.addEventListener('change', (e) => {
      const fs = e.target.closest('fieldset'); if (fs) { fs.classList.remove('opt--need'); const er = $('[data-opt-error]', fs); er && (er.textContent = ''); }
      update(true);
    });
    tiers && tiers.addEventListener('change', () => update(true));
    update(false);

    /* personalisation: letter preview on the image, month label with birthstone, engraving + font preview, photo upload */
    const pzBadge = $('[data-pz-preview]', wrap), letterSet = $('[data-letter-option]', root);
    const paintLetter = () => {
      if (!pzBadge || !letterSet) return;
      const c = $('input:checked', letterSet); pzBadge.hidden = !c; if (c) { pzBadge.textContent = c.value; pzBadge.classList.remove('pop'); void pzBadge.offsetWidth; pzBadge.classList.add('pop'); }
    };
    const paintMonth = () => $$('.opt--month', root).forEach((fs) => { const c = $('input:checked', fs), l = $('[data-month-label]', fs); if (c && l && c.dataset.monthName) l.textContent = c.dataset.monthName; });
    picker && picker.addEventListener('change', () => { paintLetter(); paintMonth(); });
    paintLetter(); paintMonth();

    $$('[data-engrave]', wrap).forEach((inp) => {
      const box = inp.closest('[data-engrave-box]') || inp.closest('.engrave'), count = $('[data-engrave-count]', box), err = $('[data-engrave-error]', box), prev = $('[data-engrave-preview]', box);
      const max = inp.maxLength, ph = prev ? prev.textContent : '';
      const paint = () => {
        count.textContent = `${inp.value.length}/${max}`;
        const ok = inp.checkValidity() || (!inp.value && !inp.required);
        err.textContent = inp.value && !inp.validity.valid ? 'Letters, numbers, spaces and ♥ only.' : '';
        inp.setAttribute('aria-invalid', String(!ok && !!inp.value));
        if (prev) prev.textContent = inp.value || ph;
      };
      inp.addEventListener('input', paint);
      $$('[data-engrave-font]', box).forEach((f) => f.addEventListener('change', () => { if (prev) prev.className = 'ef-' + f.dataset.engraveFont; }));
    });

    $$('[data-photo]', wrap).forEach((inp) => {
      const box = inp.closest('[data-photo-box]'), err = $('[data-photo-error]', box), prev = $('[data-photo-preview]', box), maxMb = Number(box.dataset.maxMb) || 20;
      inp.addEventListener('change', () => {
        const f = inp.files && inp.files[0]; err.textContent = ''; inp.removeAttribute('aria-invalid');
        if (!f) return;
        if (!/^image\/(jpeg|png|heic|heif|webp)$/i.test(f.type) && !/\.(jpe?g|png|heic|webp)$/i.test(f.name)) { err.textContent = 'Please choose a JPG, PNG, HEIC or WEBP photo.'; inp.value = ''; inp.setAttribute('aria-invalid', 'true'); return; }
        if (f.size > maxMb * 1048576) { err.textContent = `That photo is ${(f.size / 1048576).toFixed(1)} MB. Please use one under ${maxMb} MB.`; inp.value = ''; inp.setAttribute('aria-invalid', 'true'); return; }
        if (prev && /^image\/(jpeg|png|webp)$/i.test(f.type)) { const url = URL.createObjectURL(f); prev.innerHTML = `<img src="${url}" alt="" width="88" height="88">`; }
        T.say('Photo added: ' + f.name);
      });
      /* photo charms: live preview on the featured image + "Adjust photo" editor (assets/photo-charm.js, loaded once) */
      if (box.dataset.pw && box.dataset.pwJs) loadPhotoCharm(box).then((PC) => PC.attach(root, box, inp, T)).catch(() => {});
    });

    /* validate personalisation before add to bag; friendly inline errors, focus the first problem */
    form && form.addEventListener('theme:validate', (e) => {
      if (picker && incomplete) {
        const fs = $$('fieldset', picker).find((f) => !$('input:checked', f));
        if (fs) {
          e.preventDefault(); fs.classList.add('opt--need');
          const er = $('[data-opt-error]', fs), msg = fs.dataset.need || T.strings.unavailable; er && (er.textContent = msg);
          fs.scrollIntoView({ block: 'center', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
          const first = $('input', fs); first && first.focus({ preventScroll: true }); T.say(msg);
          return;
        }
      }
      const fields = $$(`[form="${form.id}"][data-pz-required], [data-pz-required]`, document).filter((i) => i.form === form);
      let first = null;
      fields.forEach((i) => {
        const empty = i.type === 'file' ? !(i.files && i.files.length) : !i.value.trim();
        const box = i.closest('[data-photo-box],[data-engrave-box]'), err = box && $('[data-photo-error],[data-engrave-error]', box);
        if (empty) { if (err) err.textContent = i.dataset.pzRequired; i.setAttribute('aria-invalid', 'true'); first = first || i; }
      });
      const bad = $$('[data-engrave]', document).find((i) => i.form === form && i.value && !i.validity.valid);
      if (bad) first = first || bad;
      if (first) { e.preventDefault(); first.focus(); first.scrollIntoView({ block: 'center', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' }); T.say(first.getAttribute('aria-label') || 'Please complete your personalisation'); }
    });

    /* "order today, ships by <date>": N business days out (block setting), shown only once JS has the date */
    $$('[data-ship-by]', root).forEach((el) => {
      const d = new Date(); let n = Number(el.dataset.shipBy) || 0;
      while (n > 0) { d.setDate(d.getDate() + 1); if (d.getDay() % 6) n--; }
      const b = $('b', el); if (b) b.textContent = d.toLocaleDateString(undefined, { weekday: 'short', month: 'short', day: 'numeric' });
      el.hidden = false;
    });

    /* quantity */
    $$('[data-step]', root).forEach((b) => b.addEventListener('click', () => {
      const q = $('[data-qty]', root); q.value = Math.max(1, (parseInt(q.value, 10) || 1) + Number(b.dataset.step));
    }));

    /* sticky add to bag on phones whenever the main button is off screen: from the first screen (button below the fold) and after it scrolls away */
    if (sticky && addBtn && 'IntersectionObserver' in window && !root.closest('[data-qv]')) {
      const mq = matchMedia('(max-width: 860px)');
      new IntersectionObserver(([e]) => {
        const show = mq.matches && !e.isIntersecting;
        sticky.classList.toggle('is-visible', show); sticky.setAttribute('aria-hidden', String(!show));
        const sb = $('[data-sticky-button]', sticky); sb && (sb.tabIndex = show ? 0 : -1);
      }).observe(addBtn);
    }

    /* landing: final CTA scrolls back to the offer */
    $$('[data-scroll-to-buy]').forEach((a) => a.addEventListener('click', (e) => {
      if (a.getAttribute('href') !== '#MainContent') return;
      e.preventDefault(); root.scrollIntoView({ behavior: 'smooth' }); setTimeout(() => addBtn && addBtn.focus({ preventScroll: true }), 500);
    }));

    /* offer + free-shipping lines follow the bag: re-render them after an add or any bag change */
    const info = $('[data-pdp-cart-info]', root);
    if (info && root.dataset.section && !root.closest('[data-qv]')) {
      let tm;
      const refresh = () => {
        clearTimeout(tm);
        tm = setTimeout(() => fetch(`${location.pathname}?section_id=${encodeURIComponent(root.dataset.section)}`, { headers: { Accept: 'text/html' } })
          .then((r) => (r.ok ? r.text() : Promise.reject()))
          .then((html) => { const f = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-pdp-cart-info]'); if (f && f.innerHTML !== info.innerHTML) info.innerHTML = f.innerHTML; })
          .catch(() => {}), 250);
      };
      document.addEventListener('theme:analytics', (e) => { if (e.detail && e.detail.name === 'add_to_cart') refresh(); });
      const cc = $('[data-cart-count]'); if (cc && 'MutationObserver' in window) new MutationObserver(refresh).observe(cc, { childList: true, characterData: true, subtree: true });
      addEventListener('pageshow', (e) => { if (e.persisted) refresh(); });
    }

    T.track('view_item', { items: [T.item({ product_id: data.id, variant_id: current && current.id, title: data.title, type: data.type, price: current && current.price })] });
  }

  /* photo-charm.js + .css, fetched only when a product has a photo window (product page or quick view) */
  var pcLoad; /* var: init() runs above this line */
  function loadPhotoCharm(box) {
    if (!document.querySelector('link[data-pw-css]')) { const l = document.createElement('link'); l.rel = 'stylesheet'; l.href = box.dataset.pwCss; l.dataset.pwCss = ''; document.head.appendChild(l); }
    if (window.PhotoCharm) return Promise.resolve(window.PhotoCharm);
    return pcLoad || (pcLoad = new Promise((res, rej) => {
      const s = document.createElement('script'); s.src = box.dataset.pwJs; s.async = true;
      s.onload = () => (window.PhotoCharm ? res(window.PhotoCharm) : rej(new Error('photo-charm')));
      s.onerror = () => { pcLoad = null; rej(new Error('photo-charm')); };
      document.head.appendChild(s);
    }));
  }

  /* recommendations (FBT + you may also like), loaded after paint */
  const loadRecs = (el) => fetch(el.dataset.url).then((r) => r.text()).then((html) => {
    const doc = new DOMParser().parseFromString(html, 'text/html'), fresh = doc.querySelector('[data-recs]');
    if (fresh) { el.innerHTML = fresh.innerHTML; if (!fresh.innerHTML.trim()) el.hidden = true; T.initProgress && T.initProgress(el); }
    const list = el.querySelector('[data-list-name]');
    if (list) T.track('view_item_list', { item_list_name: list.dataset.listName, items: T.$$('[data-card]', list).map(T.cardItem) });
  }).catch(() => { el.hidden = true; });
  const recs = $$('[data-recs]');
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver((es) => es.forEach((e) => { if (e.isIntersecting) { io.unobserve(e.target); loadRecs(e.target); } }), { rootMargin: '400px' });
    recs.forEach((r) => io.observe(r));
  } else recs.forEach(loadRecs);

  /* frequently bought together: live total + add all in one request */
  document.addEventListener('change', (e) => {
    const box = e.target.closest('[data-fbt]'); if (!box) return;
    const total = $$('[data-fbt-item]:checked', box).reduce((a, i) => a + Number(i.dataset.price), 0);
    $('[data-fbt-total]', box).textContent = T.money(total);
  });
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-fbt-add]'); if (!btn) return;
    const box = btn.closest('[data-fbt]');
    const items = $$('[data-fbt-item]:checked', box).map((i) => ({ id: Number(i.dataset.variantId), quantity: 1 }));
    if (!items.length) return;
    T.btn(btn, 'loading');
    T.add({ items }, false).then(() => { T.btn(btn, 'done'); T.openCart(btn); }).catch((ex) => { T.btn(btn); T.toast(ex.message, true); });
  });
  };
  if (window.theme && window.theme.$$) boot(); else document.addEventListener('DOMContentLoaded', boot);
})();
